import Parse from '@/parse'
const Quizset = Parse.Object.extend('Quizset')
const messages = {
  new: 'クイズセットを作成しました。',
  update: 'クイズセットを更新しました。'
}

export default {
  initForm ({ state, commit }) {
    commit('setName', state.quizset.get('name'))
    commit('setMap', state.quizset.get('map'))
    commit('setMapChanged', false)
  },

  resetForm ({ commit }) {
    commit('setName', '')
    commit('setMap', '')
    commit('setMapChanged', false)
  },

  retrieveQuizsets ({ commit }) {
    let query = new Parse.Query(Quizset)
    query.descending('createdAt')
    query.find().then((results) => {
      commit('setQuizsets', results)
    }).catch((error) => {
      console.log(error)
    })
  },

  async getQuizset ({ commit }, id) {
    let query = new Parse.Query(Quizset)
    try {
      let object = await query.get(id)
      commit('setQuizset', object)
    } catch (error) {
      console.log(error)
    }
  },

  async saveQuizset ({ state, dispatch }, action) {
    let quizset = state.quizset
    if (action === 'new') {
      quizset = new Quizset()
    }

    quizset.set('name', state.name)

    if (state.map !== '' && state.mapChanged) {
      quizset.set('map', state.map)
      let file = new Parse.File('file', { base64: state.map })
      quizset.set('map', file)
    }

    try {
      await quizset.save()

      return messages[action]
    } catch (error) {
      dispatch(
        'snackBar/addMessage',
        error,
        { root: true }
      )
    }
  },

  deleteQuizset({ state, commit }) {
    state.quizset.destroy().then(() => {
      commit(
        'snackBar/addMessage',
        'クイズセットを削除しました。',
        { root: true }
      )
    })
  },

  async copy ({ commit, dispatch }, quizset) {
    const message = await Parse.Cloud.run('copyQuizset', {
      quizsetId: quizset.id
    })
    dispatch('retrieveQuizsets')
    commit(
      'snackBar/addMessage',
      message,
      { root: true }
    )
  }
}
